import type { CastSeekInterceptor } from '@dicetechnology/doris-plugin-chromecast-receiver';

import { liveSeekableRangePatch } from './liveSeekableRangePatch';

export const seekInterceptor: CastSeekInterceptor = async (seek, { player }) => {
    if (!liveSeekableRangePatch.isEnabled) {
        return seek;
    }

    // The old receiver used to report liveSeekableRange.start = 0 for all live streams,
    // and never updated this as the stream progressed forward. This caused the DVR window to
    // be off-sync on the sender / receiver from each other, but couldn't be fixed due to information
    // hidden by the dvrMiddleware.
    // The new receiver operates without DVR middleware, so this is not an issue anymore
    // but due to some incompatibilities we need to reproduce the same behavior for mobile senders
    // while issues are being resolved there.

    const { currentTime } = seek;

    if (currentTime == null) {
        return seek;
    }

    const isLive = player.getIsLive();
    if (!isLive) {
        return seek;
    }

    const { start } = player.getSeekableRange();
    seek.currentTime = currentTime + start;

    return seek;
};
